import {observer} from 'mobx-react-lite'
import React, {useContext} from 'react'
import {Checkbox} from '@components/common/base/checkbox'
import {multiActionsWithTasksStore} from '@components/multi-actions-with-tasks/multi-actions-with-tasks-store'
import {PropsContext, useUsersTableStore} from '../users-table-store'
import {UsersTableUtil} from '../users-table-util'

export const ToggleSelectAll = observer(() => {
  const [state, store] = useUsersTableStore()
  const props = useContext(PropsContext)
  const allSelected = UsersTableUtil.allSelectedValue(
    store.allSelected,
    state.tasksOnUser
  )
  const value =
    state.toggle && multiActionsWithTasksStore.state.visible
      ? allSelected
      : store.allSelected
  return (
    <Checkbox
      className="w-full"
      value={value}
      stopPropagation={true}
      onChange={value => {
        store.toggleTurnOff()
        const changedUserIds = store.setAllSelected(value)
        props.onToggled?.(changedUserIds)
        props.onSelectedChanged?.([...state.selected])
      }}
    />
  )
})
